import {ModuleIconInterface} from "../module-icon.interface";

export class SvgIcon {
    [key: string]: string | ModuleIconInterface
}

export const ICONSACTIVITYMODULE: SvgIcon = {
    'bookmark-added': {
        icon_path: 'activities',
        icon_name: 'bookmark_added'
    },
    'button-audio__icon': {
        icon_path: 'activities',
        icon_name: 'equalizer_1'
    },
    'check': {
        icon_path: 'activities',
        icon_name: 'check'
    },
    'equalizer_1': {
        icon_path: 'activities',
        icon_name: 'equalizer_1'
    },
    'equalizer_2': {
        icon_path: 'activities',
        icon_name: 'equalizer_2'
    },
    'equalizer_3': {
        icon_path: 'activities',
        icon_name: 'equalizer_3'
    },
    'equalizer_4': {
        icon_path: 'activities',
        icon_name: 'equalizer_4'
    },
    'false': {
        icon_path: 'activities',
        icon_name: 'block--full'
    },
    'feedback-dialog__star': {
        icon_path: 'activities',
        icon_name: 'star'
    },
    'headphones': {
        icon_path: 'activities',
        icon_name: 'headphones'
    },
    'next':  {
        icon_path: 'activities',
        icon_name: 'keyboard_tab'
    },
    'order-matching__audio-1': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_1'
    },
    'order-matching__audio-2': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_2'
    },
    'order-matching__audio-3': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_3'
    },
    'order-matching__audio-4': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_4'
    },
    'qcm-qcu__audio-1': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_1'
    },
    'qcm-qcu__audio-2': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_2'
    },
    'qcm-qcu__audio-3': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_3'
    },
    'qcm-qcu__audio-4': {
        icon_path: 'activities',
        icon_name: 'speaker_equalizer_4'
    },
    'qcm__register__incorrect': {
        icon_path: 'activities',
        icon_name: 'close--full'
    },
    'qcm__register__not-correct': {
        icon_path: 'activities',
        icon_name: 'close--full'
    },
    'qcm__register__null': {
        icon_path: 'activities',
        icon_name: 'check--full'
    },
    'qcm__register__pristine': {
        icon_path: 'activities',
        icon_name: 'check--full'
    },
    'quit': {
        icon_path: 'activities',
        icon_name: 'reply_all'
    },
    'retry': {
        icon_path: 'activities',
        icon_name: 'restart_alt'
    },
    'sound_off': {
        icon_path: 'activities',
        icon_name: 'sound_off'
    },
    'sound_on': {
        icon_path: 'activities',
        icon_name: 'sound_on'
    },
    'true': {
        icon_path: 'activities',
        icon_name: 'download_done--full'
    },
    'voice-recorder__listen': {
        icon_path: 'activities',
        icon_name: 'volume_down'
    },
    'voice-recorder__listen-and-compare': {
        icon_path: 'activities',
        icon_name: 'headphones'
    },
    'voice-recorder__record': {
        icon_path: 'activities',
        icon_name: 'mic'
    },
    'voice-recorder__stop-recording': {
        icon_path: 'activities',
        icon_name: 'stop'
    },
}